import { makeStyles } from 'tss-react/mui';

const name = 'ChainSelectors';

export const useChainSelectorsStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  tab: {
    flex: 1,

    '&&': {
      h3: {
        height: 36,
      },
    },
  },
  tabs: {
    height: 40,
    width: '100%',
  },
  tabsInner: {
    width: '100%',
  },
  tabsWrapper: {
    width: '100%',
  },
  groupSelectSelect: {
    '&&': {
      width: '100%',
      height: 40,
    },
  },
  groupSelectInput: {
    '&&': {
      width: '100%',
    },
  },
}));
